import React, { useEffect, useRef, useCallback } from "react";
//Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";

import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import withRouter from "../../Components/Common/withRouter";
import {
  PermissionActionWrapper,
  ProductsEntity,
} from "shared/permissionWrapper";

const SidebarContent = (props: any) => {
  const ref = useRef<any>(null);
  const activateParentDropdown = useCallback((item: any) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const activeMenu = useCallback(() => {
    const pathName = process.env.PUBLIC_URL + props.router.location.pathname;
    let matchingMenuItem = null;
    const ul: any = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [props.router.location.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item: any) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>
            <li>
              <Link to="/dashboard" className="has-arrow">
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Dashboards")}</span>
              </Link>
              {/* <ul className="sub-menu">
                <li>
                  <Link to="/Accounts">{props.t("Accounts")}</Link>
                </li>
                <li>
                  <Link to="/Acquisition">{props.t("Acquisition")}</Link>
                </li>
                <li>
                  <Link to="/dashboard-cards">{props.t("Cards")}</Link>
                </li>
              </ul> */}
            </li>
            <ProductsEntity prod={["VIEW_MYACCOUNTS"]}>
              <PermissionActionWrapper action="VIEW_MYACCOUNTS">
                <li>
                  <Link to="/myaccounts">
                    <i className="mdi mdi-account-box-multiple-outline"></i>
                    <span>{props.t("My Accounts")}</span>
                  </Link>
                </li>
              </PermissionActionWrapper>
            </ProductsEntity>
            <ProductsEntity prod={["VIEW_WALLET"]}>
              <PermissionActionWrapper action="VIEW_MYACCOUNTS">
                <li>
                  <Link to="/wallet">
                    <i className="mdi mdi-account-box-multiple-outline"></i>
                    <span>{props.t("Wallet")}</span>
                  </Link>
                </li>
              </PermissionActionWrapper>
            </ProductsEntity>
            <ProductsEntity prod={["VIEW_CARDS"]}>
              <PermissionActionWrapper action="VIEW_CARDS">
                <li>
                  <Link to="/Cards">
                    <i className="mdi mdi-credit-card-outline"></i>
                    <span>{props.t("Cards")}</span>
                  </Link>
                </li>
              </PermissionActionWrapper>
            </ProductsEntity>
            <ProductsEntity prod={["VIEW_SERVICES_PAYMENT"]}>
              <PermissionActionWrapper action="VIEW_PAYMENTS">
                <li>
                  <Link to="/paymentService">
                    <i className="mdi mdi-room-service-outline"></i>
                    <span>{props.t("Payment of services")}</span>
                  </Link>
                </li>
              </PermissionActionWrapper>
            </ProductsEntity>
            <ProductsEntity prod={["VIEW_MASS_TRANSFERS"]}>
              <PermissionActionWrapper action="VIEW_MASSTRANSFERS">
                <li>
                  <Link to="/mass-transfers">
                    <i className="bx bx-transfer"></i>
                    <span>{props.t("Mass transfers")}</span>
                  </Link>
                </li>
              </PermissionActionWrapper>
            </ProductsEntity>
            <ProductsEntity prod={["VIEW_CREDITS"]}>
              <PermissionActionWrapper action="VIEW_CREDITS">
                <li>
                  <Link to="/credits">
                    <i className="mdi mdi-star-three-points-outline"></i>
                    <span>{props.t("Credits")}</span>
                  </Link>
                </li>
              </PermissionActionWrapper>
            </ProductsEntity>
            <ProductsEntity prod={["VIEW_CARD_AQUIRANCE"]}>
              <PermissionActionWrapper action="VIEW_CARD_AQUIRANCE">
                <li>
                  <Link to="/card-aquirance" className="has-arrow">
                    <i className="bx bxl-visa" style={{ fontSize: "25px" }}></i>
                    <span>{props.t("Card Acquirance")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/payment-link">{props.t("Payment Link")}</Link>
                    </li>
                    <li>
                      <Link to="/payment-button">
                        {props.t("Payment Button")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/suscriptions">{props.t("Suscriptions")}</Link>
                    </li>
                    <li>
                      <Link to="/appereance">{props.t("Appereance")}</Link>
                    </li>
                    <li>
                      <Link to="/card-information">
                        {props.t("Card Information")}
                      </Link>
                    </li>
                  </ul>
                </li>
              </PermissionActionWrapper>
            </ProductsEntity>
            {/* <PermissionRoleWrapper roles={["admin"]}>
            </PermissionRoleWrapper> */}
            {/* <PermissionActionWrapper action="VIEW_CARDS"></PermissionActionWrapper> */}
            {/* ----------------------------------------------------------------------------------------------------------------- */}
            <li className="menu-title">{props.t("Institutional")}</li>

            <ProductsEntity prod={["VIEW_DIGITAL_ASSET"]}>
              <PermissionActionWrapper action="VIEW_DIGITAL_ASSETS">
                <li>
                  <Link to="/digital-assets">
                    <i className="bx bx-money"></i>
                    <span>{props.t("Digital Assets")}</span>
                  </Link>
                </li>
              </PermissionActionWrapper>
            </ProductsEntity>
            <ProductsEntity prod={["VIEW_REMITTANCES"]}>
              <PermissionActionWrapper action="VIEW_REMITTANCES">
                <li>
                  <Link to="/remittances">
                    <i className="mdi mdi-send-check-outline"></i>
                    <span>{props.t("Remittances")}</span>
                  </Link>
                </li>
              </PermissionActionWrapper>
            </ProductsEntity>
            <ProductsEntity prod={["VIEW_DIGITAL_CORRESPONDENT"]}>
              <PermissionActionWrapper action="VIEW_DIGITAL_CORRESPONDENT">
                <li>
                  <Link to="/digital-correspondet">
                    <i className="mdi mdi-email-check-outline"></i>
                    <span>{props.t("Digital Correspondent")}</span>
                  </Link>
                </li>
              </PermissionActionWrapper>
            </ProductsEntity>
            <ProductsEntity prod={["VIEW_CREDIT_ORIGINATION"]}>
              <PermissionActionWrapper action="VIEW_CREDIT_ORIGINATION">
                <li>
                  <Link to="/credit-origination">
                    <i className="mdi mdi-credit-card-settings-outline"></i>
                    <span>{props.t("Credit Origination")}</span>
                  </Link>
                </li>
              </PermissionActionWrapper>
            </ProductsEntity>

            {/* ----------------------------------------------------------------------------------------------------------------- */}
            <li className="menu-title">{props.t("Settings")}</li>
            <PermissionActionWrapper action="RO0001">
              <li>
                <Link to="/roles">
                  <i className="mdi mdi-account-switch"></i>
                  <span>{props.t("Roles")}</span>
                </Link>
              </li>
            </PermissionActionWrapper>
            <PermissionActionWrapper action="US0001">
              <li>
                <Link to="/user-system">
                  <i className="mdi mdi-account-group"></i>
                  <span>{props.t("Users System")}</span>
                </Link>
              </li>
            </PermissionActionWrapper>
            <ProductsEntity prod={["VIEW_COMPANY_DATA"]}>
              <PermissionActionWrapper action="VIEW_COMPANY_DATA">
                <li>
                  <Link to="/company-data">
                    <i className="bx bx-file"></i>
                    <span>{props.t("Company Data")}</span>
                  </Link>
                </li>
              </PermissionActionWrapper>
            </ProductsEntity>
            <PermissionActionWrapper action="NO0001">
              <li>
                <Link to="/notifications">
                  <i className="mdi mdi-bell"></i>
                  <span>{props.t("Notifications")}</span>
                </Link>
              </li>
            </PermissionActionWrapper>
            <ProductsEntity prod={["VIEW_SECURITY"]}>
              <PermissionActionWrapper action="SE0001">
                <li>
                  <Link to="/security">
                    <i className="bx bxs-lock-alt"></i>
                    <span>{props.t("Security")}</span>
                  </Link>
                </li>
              </PermissionActionWrapper>
            </ProductsEntity>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};
export default withRouter(withTranslation()(SidebarContent));
